import { HttpClient } from '@angular/common/http';
import { Component, OnInit , OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { Helper } from '../helpers/helper';
import { UserService } from '../user.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit, OnDestroy {

  busy: Subscription;
  message: string;
  error: string;
  data: any;
  constructor(private userService: UserService, private router: Router, private toastr: ToastrService, private route: ActivatedRoute, private http: HttpClient) {}

  ngOnDestroy() {
    this.toastr.clear();
  }
  
  ngOnInit() {
    // const token = this.route.snapshot.queryParamMap.get('token');
    // if (!token) {
    //   this.error = 'Invalid verification token';
    //   return;
    // }
    // let params: any = this.route.snapshot.params;
    // alert(JSON.stringify(params));
    // if( params.token){
    //   console.log(params);
    //     //this.data.token = params.token;
    // }
  }

  

  verifyEmail() {
    let params: any = this.route.snapshot.params;
    let responseData = <any>{};
    this.busy =  this.userService.verifyEmail(params).subscribe(
       response => {
        responseData = response;
			  this.toastr.success(responseData.message, '');
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 3000); // Redirect after 3 seconds (adjust the delay as needed)
       },
       error => {
	    responseData = error;
        this.toastr.error(responseData.error.message, 'Failed!');
       }
    );
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/verify-email/verify-email.component.ts